import React from 'react';
import ServiceCard from '@/components/services/ServiceCard';
import { Code, Cpu, Smartphone, Clock, LineChart, TestTube2, Blocks, Rocket, Brain, Database, Shield, Cloud, Zap, Users, Lock, Globe } from 'lucide-react';
import Button from '@/components/ui/Button';

const Services = () => {
  const services = [
    
    {
      icon: <Smartphone className="w-full h-full" />,
      title: "Applications Mobiles",
      description: "Développement d'applications mobiles natives et cross-platform pour iOS et Android, optimisées pour les performances.",
      link: "/developpement-mobile"
    },
    {
      icon: <Globe className="w-full h-full" />,
      title: "Applications Web",
      description: "Développement d'applications web modernes et réactives, offrant une expérience utilisateur fluide sur tous les navigateurs.",
      link: "/developpement-web"
    },
    {
      icon: <Cloud className="w-full h-full" />,
      title: "Développement SaaS",
      description: "Création de solutions SaaS sur mesure, de l'architecture à la mise en production, avec une expertise en cloud et scalabilité.",
      link: "/developpement-saas"
    },
    {
      icon: <Zap className="w-full h-full" />,
      title: "Automatisation",
      description: "Solutions d'automatisation pour optimiser vos processus métier, réduire les coûts et augmenter la productivité.",
      link: "/ia-automatisation"
    },
    {
      icon: <Users className="w-full h-full" />,
      title: "Marketplaces",
      description: "Création de plateformes de marketplace connectant acheteurs et vendeurs, avec gestion des paiements et des transactions.",
      link: "/developpement-marketplace"
    },
    {
      icon: <LineChart className="w-full h-full" />,
      title: "Maintenance & Support",
      description: "Services de maintenance proactive, monitoring et support technique pour garantir la performance de vos solutions.",
      link: "/maintenance-support"
    }
  ];

  return (
    <section id="services" className="py-16 md:py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900">
            Solutions <span className="text-orcsys-500">Digitales</span> adaptées à votre besoin
          </h2>
          <p className="mt-4 text-base text-slate-600 max-w-2xl mx-auto leading-relaxed">
            Profesionnels en développement de solutions mobile, web, SaaS, et plateformes digitales. 
            Nous transformons vos idées en produits performants et évolutifs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <ServiceCard 
              key={index} 
              icon={service.icon} 
              title={service.title} 
              description={service.description} 
              link={service.link}
              delay={(index % 3) * 100}
            />
          ))}
        </div>

        <div className="mt-12 text-center">
          <Button.Link href="#book" className="bg-orcsys-500 hover:bg-orcsys-600 text-white shadow-lg hover:shadow-orcsys-500/25 transition-all duration-300 text-base px-6 py-2.5">
            Discuter de votre projet
          </Button.Link>
        </div>
      </div>
    </section>
  );
};

export default Services;
